import React from 'react';

import { FormattedProps } from '../types';
import { CustomTitle } from 'shared/components/presentational/Title/sharedTitles';
import {
  Link,
  List,
  ListItem,
  SectionTitle,
  Wrapper
} from '../styles/components';
import Icon from 'shared/components/presentational/Icons';

function LinkList({ title, sections }: FormattedProps) {
  return (
    <Wrapper>
      <CustomTitle htmlTag={title.htmlTag}>{title.label}</CustomTitle>
      {sections.map(section => (
        <div key={section.titleLabel}>
          <SectionTitle>{section.titleLabel}</SectionTitle>
          <List>
            {section.links.map(link => (
              <ListItem key={link.label}>
                <Link to={link.link}>
                  {link.label}
                  <Icon name="ArrowRight" />
                </Link>
              </ListItem>
            ))}
          </List>
        </div>
      ))}
    </Wrapper>
  );
}

export default LinkList;
